import MessageTipsComponent from './components/messageTips.vue'

let $vm

export default {
    install(Vue, options) {
        if (!$vm) {
            const MessageTipsPlugin = Vue.extend(MessageTipsComponent);

            $vm = new MessageTipsPlugin({
                el: document.createElement('div')
            });

            document.body.appendChild($vm.$el);
        }

        $vm.show = false;

        let messageTips = {
            show(text, type) {

                let height = 451; //窗口高度
                let width = 394; //窗口宽度
         
                let left = (window.screenX || window.screenLeft || 0) + (screen.width - width) / 2; //计算窗口位置
                let top = (window.screenY || window.screenTop || 0) + (screen.height - height-200) / 2;
                $(".nstl-templet-div2").css({top:top});
                $vm.show = true;

                // $vm.text = text;
                $("#qrcode").empty()

                if (type == 1) {
                    var qrWidth = 250;
                    var qrHeight = 250;
                    $("#qrcode").qrcode({
                        render: "canvas",
                        text: text,
                        width: qrWidth,
                        height: qrHeight,
                        logoSrc: "//www.nstl.gov.cn/favicon.ico"
                    });
                } else {
                    var scanCodeImg = "<img style='width: 177px;height: 177px;margin-top: 0px;' src='data:image/png;base64," + text + "'>"
                    $("#qrcode").html(scanCodeImg)
                }
            },
            hide() {
                $vm.show = false;
            },
            status() {
                return $vm.show;
            }

        };

        if (!Vue.$messageTips) {
            Vue.$messageTips = messageTips;
        }

        // Vue.prototype.$loading = Vue.$loading;

        Vue.mixin({
            created() {
                this.$messageTips = Vue.$messageTips;
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/assets/messageTips.js